import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const prefixUserList = 'configuration.users.list'
const translateHeaderPrefix = `${prefixUserList}.headers`

/** Filtro de admins LMS vía AbacRole is_default (no users.role_id). */
export const usePermissionsList = () => {
  const { t } = useTranslation()

  const permissionsList = useMemo(
    () => [
      {
        label: t(`${translateHeaderPrefix}.role.admin`),
        value: true,
      },
    ],
    [t]
  )

  return permissionsList
}
